import React, { Component } from 'react';
import ModalDashboard from "./ModalDashboard";
import { stubArray } from 'lodash';

class InfoCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalDashboard: false,
        };
    }

    showModalDashboard = () => {
        this.setState({ modalDashboard: true });
        $("#btn-results").click();
    };

    render() {
        const {
            type,
            selectedArea,
            meta_data,
            totalEmpreendimentos,
            oferta_lancada,
            oferta_final,
            unidadesVendidas,
            polos,
            polos_cache_key,
            setPolosGeradoresCurrentShowing,
            setLoading
        } = this.props;

        const handlePolosClick = () => {
            let agrupamentos = [];

            polos.map((polo) => {
                let found = agrupamentos.find(agrupamento => agrupamento.grupo === polo.sub_category);
                if (found) {
                    found.count++;
                } else {
                    agrupamentos.push({ grupo: polo.sub_category, count: 1 });
                }
            });

            setPolosGeradoresCurrentShowing(polos, agrupamentos, polos_cache_key);
        };

        const iconByType = {
            "Círculo": "fa-circle",
            "Círculo Manual": "fa-circle",
            "Polígono": "fa-draw-polygon",
            "Retângulo": "fa-square",
        };

        return (
            <div className="info-card area-info ov-hidden">
                {
                    type.toLowerCase() != 'cidade' &&
                    <div className="info-card-header card-header">
                        <i className={`fa-solid ${iconByType[selectedArea.type] || ""}`} style={{ color: selectedArea.color }}></i>
                        {" "}{isNaN(selectedArea.name) ? selectedArea.name : `${type.split(' ')[0]} ${selectedArea.name}`}{ }
                    </div>


                }

                <div className="card-body card-body-mapa-info">
                    <div className='font19'>
                        <span className="">Tipo da busca:</span> {type.toLowerCase()}
                    </div>

                    {selectedArea.radius !== undefined && (
                        <div className='font19'>
                            <span className="">Raio do círculo:</span> {Number(selectedArea.radius).toFixed(2)}
                        </div>
                    )}

                    <div className="info-card-badges">
                        {meta_data.request.map((param, key) => (
                            <span key={`${param.value}-${key}`} className="info-card-badge bold">{param.value.length > 280 ? param.value.substring(0, 280) + '...' : param.value}</span>
                        ))}
                    </div>
                    <hr className="info-card-hr hr-mapa" />

                    <div className='font19'><span className="info-card-label">Total de empreendimentos:</span> {totalEmpreendimentos}</div>
                    <div className='font19'><span className="info-card-label">Oferta lançada:</span> {oferta_lancada}</div>
                    <div className='font19'><span className="info-card-label">Oferta final:</span> {oferta_final}</div>
                    <div className='font19 mb-3'><span className="info-card-label">Unidades vendidas:</span> {unidadesVendidas}</div>

                    <form action={meta_data.file.pdf} method="GET">
                        <input type="hidden" name="nome" value={meta_data.cache_key} readOnly />

                        {window.verEstoqueExcelMapa && (
                            <>
                                <div className="detalhe-container">
                                    <label htmlFor={`accept${meta_data.cache_key}`}>
                                        <div className="detalhe-flex">
                                            <input
                                                className="detalhes-check-input"
                                                type="checkbox"
                                                id={`accept${meta_data.cache_key}`}
                                                name={`accept${meta_data.cache_key}`}
                                                defaultValue="true"
                                            />
                                            <span className="slider"></span>
                                            <span className="margin-check letter-spacing-1" style={{ marginLeft: '44px' }}>Detalhar empreendimentos</span>
                                        </div>
                                    </label>
                                </div>
                            </>
                        )}


                        <div className="info-card-btn-row">
                            {window.verEstoqueExcelMapa && (
                                <>
                                    <button type="submit" className="info-card-btn info-card-btn-pdf">PDF</button>
                                    <button type="submit" formAction={meta_data.file.excel} className="info-card-btn info-card-btn-xls">XLS</button>
                                </>
                            )}
                            {window.authenticatedUserCanQueryPolos && polos?.length > 0 && (
                                <button type="button" onClick={handlePolosClick} className="info-card-btn info-card-btn-polos">POLOS</button>
                            )}
                            {window.viewPdfDashboardMapa && (
                                <button type="button" onClick={this.showModalDashboard} className="info-card-btn info-card-btn-dashboard">DASHBOARD</button>
                            )}
                        </div>
                    </form>

                    <ModalDashboard
                        show={this.state.modalDashboard}
                        closeModal={() => this.setState({ modalDashboard: false })}
                        setLoading={setLoading}
                        originalState={meta_data.file.pdfdashboard}
                    />
                </div>
            </div>
        );
    }
}

export default InfoCard;
